import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const wsId = localStorage.getItem("lf_workspace_id");
  if (wsId) config.headers["X-Workspace-Id"] = wsId;
  return config;
});

export const setActiveWorkspaceId = (id) => {
  if (id) localStorage.setItem("lf_workspace_id", id);
  else localStorage.removeItem("lf_workspace_id");
};

export const getActiveWorkspaceId = () => localStorage.getItem("lf_workspace_id") || null;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
